import { Fab, Paper, Zoom } from "@material-ui/core";

import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import MeditocSubtitulo from "./MeditocSubtitulo";
import { useState } from "react";
import { useStyle } from "../../context/StyleContext";

export default function MeditocHelper(props) {
    const { title, children } = props;
    const { classes } = useStyle();

    const [fabOpen, setFabOpen] = useState(false);

    return (
        <div style={{ position: "fixed", right: "10px", top: "0%" }}>
            <div>
                <Fab
                    color="secondary"
                    className={classes.absolute}
                    onMouseEnter={() => setFabOpen(true)}
                    onMouseLeave={() => setFabOpen(false)}
                    onClick={() => setFabOpen(true)}
                >
                    <LiveHelpIcon />
                </Fab>
                <Zoom in={fabOpen}>
                    <Paper className={classes.absoluteDiv} elevation={10}>
                        <div>
                            <MeditocSubtitulo title={title} />
                        </div>
                        {children}
                    </Paper>
                </Zoom>
            </div>
        </div>
    );
}
